import auth from 'services/auth';

// The wizard's steps, parked while the applicant is away at a provider
export const STORAGE_KEY = 'partner_signup_steps';

export function readStoredSteps() {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);

    return raw ? JSON.parse(raw) : undefined;
  } catch (err) {
    return undefined;
  }
}

/**
 * Turns a proven lead into a partner and lands on its dashboard. Returns
 * whether the redirect was issued, so a caller holding the screen back knows
 * one is on its way. `leadCompleted` skips a second completion, which the
 * server refuses, when a retry follows a failed create.
 */
export async function completeSignup({
  leadId,
  proof,
  leadCompleted = false,
  onLeadCompleted,
  completeLead,
  createPartner,
  flashError,
  router,
}) {
  if (!leadCompleted) {
    const completed = await completeLead(leadId, proof);

    // Falsy means the loading middleware already flashed the server's message
    if (!completed) {
      return false;
    }

    if (completed.error || completed.errors) {
      flashError(
        completed.error || completed.errors || 'An unknown error occurred',
      );
      return false;
    }

    if (onLeadCompleted) {
      onLeadCompleted();
    }
  }

  const partner = await createPartner(leadId);

  if (!partner) {
    return false;
  }

  if (partner.error || partner.errors) {
    flashError(partner.error || partner.errors || 'An unknown error occurred');
    return false;
  }

  window.sessionStorage.removeItem(STORAGE_KEY);

  // The session is already in this partner's cookie, so stay in the app: the
  // cross-host handoff appends `to` straight onto the partner segment
  auth.redirectPartnerSessionTo(`/${partner.id}`, router);

  return true;
}
